"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "RESIZER_ATTRIBUTE_ID", {
  enumerable: true,
  get: function get() {
    return _useTableResizer.RESIZER_ATTRIBUTE_ID;
  }
});
exports.default = void 0;
var _TableResizer = _interopRequireDefault(require("./TableResizer"));
var _useTableResizer = require("./useTableResizer");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var _default = exports.default = _TableResizer.default;